export default "__VITE_PUBLIC_ASSET__95339399__"